import { createSelector } from 'reselect';

import { doPdsExist } from './pds/selectors';
import { doCutoffsExist } from './cutoffs/selectors';

import getParent from '../selectors';

export default state => getParent(state).distributions;

export const doPdsAndCutoffsExist = createSelector(
  doPdsExist,
  doCutoffsExist,

  (pdsExist, cutoffsExist) => pdsExist && cutoffsExist
);
